module.exports = __webpack_public_path__ + "static/media/page_2i_right.d871380b.png";